// extracted by mini-css-extract-plugin
export default {"app":"main_app__jdRZv","content":"main_content__mW6jh"};